const SHARE_BUTTONS_SELECTOR = '.share';

const openShareDialog = (buttonElement: Element, popupBaseUrl: string): void => {
  buttonElement.addEventListener('click', (event: Event) => {
    event.preventDefault();

    const windowHeight = Math.min(500, window.innerHeight - 50);
    const windowWidth = Math.min(600, window.innerWidth - 50);

    const urlToShare = encodeURIComponent(window.location.href);

    window.open(
      `${popupBaseUrl}${urlToShare}`,
      '_blank',
      `width=${windowWidth},height=${windowHeight},toolbar=0,menubar=0,location=0,noopener=1,noreferrer=1`,
    );
  });
};

export const initShareButtons = (): void => {
  const shareButtonFacebook = document.querySelector(`${SHARE_BUTTONS_SELECTOR}.facebook`);
  const shareButtonLinkedin = document.querySelector(`${SHARE_BUTTONS_SELECTOR}.linkedin`);
  const shareButtonTwitter = document.querySelector(`${SHARE_BUTTONS_SELECTOR}.twitter`);

  if (shareButtonFacebook) {
    openShareDialog(shareButtonFacebook, 'https://www.facebook.com/sharer/sharer.php?u=');
  }

  if (shareButtonLinkedin) {
    openShareDialog(shareButtonLinkedin, 'https://www.linkedin.com/shareArticle?mini=true&url=');
  }

  if (shareButtonTwitter) {
    openShareDialog(shareButtonTwitter, 'https://twitter.com/intent/tweet?url=');
  }
};
